// import { useEffect, useState } from "react";
// import { db, auth } from "../firebaseConfig";
// import { collection, addDoc, getDocs, serverTimestamp } from "firebase/firestore";
// import { useAuthState } from "react-firebase-hooks/auth";
// import { EditorContent, useEditor } from "@tiptap/react";
// import StarterKit from "@tiptap/starter-kit";
// import Underline from "@tiptap/extension-underline";
// import "./BlogPage.css";
// import { Link } from "react-router-dom";


// const BlogPage = () => {
//   const [user] = useAuthState(auth);
//   const [title, setTitle] = useState("");
//   const [authorName, setAuthorName] = useState("");
//   const [blogs, setBlogs] = useState([]);
//   const [comments, setComments] = useState({});
//   const [newComments, setNewComments] = useState({});
//   const [content, setContent] = useState("");

//   // Pagination State
//   const [currentPage, setCurrentPage] = useState(1);
//   const blogsPerPage = 1;

//   const editor = useEditor({
//     extensions: [StarterKit, Underline],
//     content: "",
//     onUpdate: ({ editor }) => {
//       setContent(editor.getHTML());
//     },
//   });

//   useEffect(() => {
//     const fetchBlogs = async () => {
//       const querySnapshot = await getDocs(collection(db, "publishedBlogs"));
//       setBlogs(querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
//     };
//     fetchBlogs();
//   }, []);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!user) return alert("Please log in to submit a blog.");

//     await addDoc(collection(db, "pendingBlogs"), {
//       title,
//       content,
//       author: authorName || user.displayName,
//       userId: user.uid,
//       timestamp: serverTimestamp(),
//     });

//     setTitle("");
//     setContent("");
//     setAuthorName("");
//     editor.commands.clearContent(); // Clears editor content
//     alert("Blog submitted for review.");
//   };

//   useEffect(() => {
//     if (blogs.length === 0) return;

//     const fetchComments = async () => {
//       let tempComments = {};
//       for (let blog of blogs) {
//         const commentDocs = await getDocs(collection(db, "publishedBlogs", blog.id, "comments"));
//         tempComments[blog.id] = commentDocs.docs.map((doc) => doc.data());
//       }
//       setComments(tempComments);
//     };
//     fetchComments();
//   }, [blogs]);

//   const handleComment = async (blogId) => {
//     if (!user) return alert("Please log in to comment.");
//     const commentText = newComments[blogId];
//     if (!commentText.trim()) return;

//     await addDoc(collection(db, "publishedBlogs", blogId, "comments"), {
//       text: commentText,
//       author: user.displayName,
//       timestamp: serverTimestamp(),
//     });

//     setNewComments({ ...newComments, [blogId]: "" });

//     // Fetch updated comments immediately
//     const updatedComments = await getDocs(collection(db, "publishedBlogs", blogId, "comments"));
//     setComments((prev) => ({
//       ...prev,
//       [blogId]: updatedComments.docs.map((doc) => doc.data()),
//     }));
//   };

//   // Pagination Logic
//   const indexOfLastBlog = currentPage * blogsPerPage;
//   const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
//   const currentBlogs = blogs.slice(indexOfFirstBlog, indexOfLastBlog);

//   return (
//     <div className="blog-container">
//       <h2 className="blog-title">Submit a Blog</h2>
//       <div className="blog-form-titles-container">
//       <div className="blog-form-container">
//         {user ? (
//           <form className="blog-form" onSubmit={handleSubmit}>
//             <input
//               type="text"
//               placeholder="Title"
//               value={title}
//               onChange={(e) => setTitle(e.target.value)}
//               required
//               className="blog-input"
//             />

//             {/* Formatting Toolbar */}
//             <div className="toolbar">
//               <button type="button" onClick={() => editor.chain().focus().toggleBold().run()}>
//                 <b>B</b>
//               </button>
//               <button type="button" onClick={() => editor.chain().focus().toggleItalic().run()}>
//                 <i>I</i>
//               </button>
//               <button type="button" onClick={() => editor.chain().focus().toggleUnderline().run()}>
//                 <u>U</u>
//               </button>
//               <button type="button" onClick={() => editor.chain().focus().setParagraph().run()}>
//                 P
//               </button>
//               <button type="button" onClick={() => editor.chain().focus().toggleHeading({ level: 1 }).run()}>
//                 H1
//               </button>
//               <button type="button" onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()}>
//                 H2
//               </button>
//               <button type="button" onClick={() => editor.chain().focus().toggleBulletList().run()}>
//                 • List
//               </button>
//               <button type="button" onClick={() => editor.chain().focus().toggleOrderedList().run()}>
//                 1. List
//               </button>
//             </div>

//             {/* Tiptap Editor */}
//             <div className="editor-container">
//               <EditorContent editor={editor} className="editor" />
//             </div>

//             <input
//               type="text"
//               placeholder="Your Name"
//               value={authorName}
//               onChange={(e) => setAuthorName(e.target.value)}
//               className="blog-input"
//             />
//             <button type="submit" className="blog-button">
//               Submit
//             </button>
//           </form>
//         ) : (
//           <p className="login-message">Please log in to submit a blog.</p>
//         )}
//       </div>


    
//       <div className="bl-container">
//   <h2 className="blog-title-list">All Blog Titles</h2>
//   <ul className="blog-titles-list">
//     {blogs.map((blog) => (
//       <li key={blog.id} className="blog-title-item">
//         <Link to={`/blog/${blog.id}`} className="bl-title">{blog.title}</Link>  
//         <span className="blog-author"> - {blog.author}</span>
//       </li>
//     ))}
//   </ul>
// </div>



//       </div> 

//       <h2 className="pb-title">Published Blogs</h2>
//       <div className="blogs-grid">
//         {currentBlogs.map((blog) => (
//           <div key={blog.id} className="blog-post">
//             <h3 className="blog-post-title">{blog.title}</h3>
//             <div className="blog-post-content" dangerouslySetInnerHTML={{ __html: blog.content }} />
//             <p className="blog-author">
//               <b>Author:</b> {blog.author}
//             </p>

//             <h4 className="comment-title">Comments:</h4>
//             {comments[blog.id]?.map((comment, index) => (
//               <p key={index} className="blog-comment">
//                 <b>{comment.author}:</b> {comment.text}
//               </p>
//             ))}

//             {user && (
//               <div className="comment-section">
//                 <input
//                   type="text"
//                   placeholder="Write a comment..."
//                   value={newComments[blog.id] || ""}
//                   onChange={(e) => setNewComments({ ...newComments, [blog.id]: e.target.value })}
//                   className="comment-input"
//                 />
//                 <button onClick={() => handleComment(blog.id)} className="comment-button">
//                   Post Comment
//                 </button>
//               </div>
//             )}
//           </div>
//         ))}
//       </div>

//       {/* Pagination Controls */}
//       <div className="pagination">
//         <button onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 1} className="pagination-button">
//           Previous
//         </button>
//         <span> Page {currentPage} </span>
//         <button onClick={() => setCurrentPage(currentPage + 1)} disabled={indexOfLastBlog >= blogs.length} className="pagination-button">
//           Next
//         </button>
//       </div>
//     </div>
//   );
// };

// export default BlogPage;



import { useEffect, useState } from "react";
import { db, auth } from "../firebaseConfig";
import { collection, addDoc, getDocs, serverTimestamp } from "firebase/firestore";
import { useAuthState } from "react-firebase-hooks/auth";
import { EditorContent, useEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import Underline from "@tiptap/extension-underline";
import "./BlogPage.css";
import { Link } from "react-router-dom";

const BlogPage = () => {
  const [user] = useAuthState(auth);
  const [title, setTitle] = useState("");
  const [authorName, setAuthorName] = useState("");
  const [blogs, setBlogs] = useState([]);
  const [comments, setComments] = useState({});
  const [newComments, setNewComments] = useState({});
  const [content, setContent] = useState("");
  const [showModal, setShowModal] = useState(false); // Controls modal visibility

  // Pagination State
  const [currentPage, setCurrentPage] = useState(1);
  const blogsPerPage = 1;

  const editor = useEditor({
    extensions: [StarterKit, Underline],
    content: "",
    onUpdate: ({ editor }) => {
      setContent(editor.getHTML());
    },
  });

  useEffect(() => {
    const fetchBlogs = async () => {
      const querySnapshot = await getDocs(collection(db, "publishedBlogs"));
      setBlogs(querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
    };
    fetchBlogs();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!user) return alert("Please log in to submit a blog.");

    await addDoc(collection(db, "pendingBlogs"), {
      title,
      content,
      author: authorName || user.displayName,
      userId: user.uid,
      timestamp: serverTimestamp(),
    });

    setTitle("");
    setContent("");
    setAuthorName("");
    editor.commands.clearContent(); // Clears editor content
    alert("Blog submitted for review.");
    setShowModal(false); // Close modal after submission
  };

  useEffect(() => {
    if (blogs.length === 0) return;

    const fetchComments = async () => {
      let tempComments = {};
      for (let blog of blogs) {
        const commentDocs = await getDocs(collection(db, "publishedBlogs", blog.id, "comments"));
        tempComments[blog.id] = commentDocs.docs.map((doc) => doc.data());
      }
      setComments(tempComments);
    };
    fetchComments();
  }, [blogs]);

  const handleComment = async (blogId) => {
    if (!user) return alert("Please log in to comment.");
    const commentText = newComments[blogId];
    if (!commentText.trim()) return;

    await addDoc(collection(db, "publishedBlogs", blogId, "comments"), {
      text: commentText,
      author: user.displayName,
      timestamp: serverTimestamp(),
    });

    setNewComments({ ...newComments, [blogId]: "" });

    // Fetch updated comments immediately
    const updatedComments = await getDocs(collection(db, "publishedBlogs", blogId, "comments"));
    setComments((prev) => ({
      ...prev,
      [blogId]: updatedComments.docs.map((doc) => doc.data()),
    }));
  };

  // Pagination Logic
  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const currentBlogs = blogs.slice(indexOfFirstBlog, indexOfLastBlog);

  return (
    <div className="blog-container">
      {/* Submit a Blog Button */}
      <button className="open-modal-btn" onClick={() => setShowModal(true)}>
        Submit a Blog
      </button>

      {/* Blog Submission Modal */}
      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <span className="close-modal" onClick={() => setShowModal(false)}>
              &times;
            </span>
            {user ? (
              <form className="blog-form" onSubmit={handleSubmit}>
                <h2>Submit a Blog</h2>
                <input
                  type="text"
                  placeholder="Title"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  required
                  className="blog-input"
                />

                {/* Formatting Toolbar */}
                <div className="toolbar">
                  <button type="button" onClick={() => editor.chain().focus().toggleBold().run()}>
                    <b>B</b>
                  </button>
                  <button type="button" onClick={() => editor.chain().focus().toggleItalic().run()}>
                    <i>I</i>
                  </button>
                  <button type="button" onClick={() => editor.chain().focus().toggleUnderline().run()}>
                    <u>U</u>
                  </button>
                </div>

                {/* Tiptap Editor */}
                <div className="editor-container">
                  <EditorContent editor={editor} className="editor" />
                </div>

                <input
                  type="text"
                  placeholder="Your Name"
                  value={authorName}
                  onChange={(e) => setAuthorName(e.target.value)}
                  className="blog-input"
                />
                <button type="submit" className="blog-button">
                  Submit
                </button>
              </form>
            ) : (
              <p>Please log in to submit a blog.</p>
            )}
          </div>
        </div>
      )}

      {/* Blog Titles */}
      <div className="bl-container">
        <h2 className="blog-title-list">All Blog Titles</h2>
        <ul className="blog-titles-list">
          {blogs.map((blog) => (
            <li key={blog.id} className="blog-title-item">
              <Link to={`/blog/${blog.id}`} className="bl-title">{blog.title}</Link>
              <span className="blog-author"> - {blog.author}</span>
            </li>
          ))}
        </ul>
      </div>

      {/* Published Blogs */}
      <h2 className="pb-title">Published Blogs</h2>
      <div className="blogs-grid">
        {currentBlogs.map((blog) => (
          <div key={blog.id} className="blog-post">
            <h3>{blog.title}</h3>
            <div dangerouslySetInnerHTML={{ __html: blog.content }} />
            <p><b>Author:</b> {blog.author}</p>

            <h4>Comments:</h4>
            {comments[blog.id]?.map((comment, index) => (
              <p key={index}><b>{comment.author}:</b> {comment.text}</p>
            ))}

            {user && (
              <div className="comment-section">
                <input
                  type="text"
                  placeholder="Write a comment..."
                  value={newComments[blog.id] || ""}
                  onChange={(e) => setNewComments({ ...newComments, [blog.id]: e.target.value })}
                />
                <button onClick={() => handleComment(blog.id)}>Post Comment</button>
              </div>
            )}
            {/* Pagination Controls */}
<div className="pagination">
  <button
    onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
    disabled={currentPage === 1}
  >
    Previous
  </button>
  <span>Page {currentPage} of {Math.ceil(blogs.length / blogsPerPage)}</span>
  <button
    onClick={() => setCurrentPage((prev) => Math.min(prev + 1, Math.ceil(blogs.length / blogsPerPage)))}
    disabled={currentPage === Math.ceil(blogs.length / blogsPerPage)}
  >
    Next
  </button>
</div>

          </div>
        ))}
      </div>
    </div>
  );
};

export default BlogPage;




